import { render, staticRenderFns } from "./ModalFeedbackDetail.vue?vue&type=template&id=39371f9c&"
import script from "./ModalFeedbackDetail.vue?vue&type=script&lang=js&"
export * from "./ModalFeedbackDetail.vue?vue&type=script&lang=js&"
import style0 from "./ModalFeedbackDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports